Ext.define('SA.view.scatterplot.ScatterPlotPointPopup', {
    alias: 'widget.scatter-plot-point-popup',
    extend: 'Ext.Component',

    cls: 'sa-scatter-plot-point-popup',
    style: {zIndex: SA.ZIndexes.forPopup()},

    tpl: [
        '<table>',
            '<thead>',
                '<tr>',
                    '<th>Location</th>',
                    '<th>X Value</th>',
                    '<th>Y Value</th>',
                '</tr>',
            '</thead>',
            '<tbody>',
                '<tpl for=".">',
                    '<tr>',
                        '<td>{.:locationRenderer}</td>',
                        '<td>{x:htmlEncode}</td>',
                        '<td>{y:htmlEncode}</td>',
                    '</tr>',
                '</tpl>',
            '</tbody>',
        '</table>'
    ],

    initComponent() {
        var {xAttribute, yAttribute} = this,
            [xAttributeItem, yAttributeItem] = SA.data.AttributesCache.get([xAttribute, yAttribute]);

        this.sticky = this.sticky || false;

        this.callParent();

        this.update(this.data.map(data => {
            var location = SA.data.LocationsCache.get(data.locationSeries);

            return {
                name: data.name,
                locationAlias: location && location.locationAlias,
                x: SA.data.AttributesCache.formatValue(data[xAttribute], xAttributeItem.formatString),
                y: SA.data.AttributesCache.formatValue(data[yAttribute], yAttributeItem.formatString)
            };
        }));
    },

    afterRender() {
        this.callParent();

        this.syncPosition();
    },

    initEvents() {
        this.callParent();

        this.mon(Ext.getDoc(), 'click', this.onClickDoc, this);
    },

    isSticky() {
        return this.sticky;
    },

    onClickDoc(ev) {
        if (!this.getEl().dom.contains(ev.getTarget()) && !this.point.contains(ev.getTarget())) {
            this.destroy();
        }
    },

    syncPosition() {
        var offsetY = 10,
            width = this.getWidth(),
            height = this.getHeight(),
            pointRect = this.point.getBoundingClientRect(),
            pointX = (pointRect.left + pointRect.right) / 2,
            pointY = (pointRect.top + pointRect.bottom) / 2,
            offsetParent = this.getEl().dom.offsetParent,
            {left: parentLeft, top: parentTop} = offsetParent.getBoundingClientRect(),
            x = pointX - parentLeft + offsetParent.scrollLeft,
            y = pointY - parentTop + offsetParent.scrollTop,
            left = Ext.Number.constrain(x - width / 2, 0, offsetParent.scrollWidth - width),
            top = y - offsetY - height;

        if (top < 0) {
            top = y + offsetY;
        }

        this.setPosition(left, top);
    }
});